import { cloneDeep } from "lodash";


function updateStatistics(statistics, incomingPercentiles) {
  const result = cloneDeep(statistics);

  if (incomingPercentiles) {
    result.originalPercentiles =
      statistics.originalPercentiles ?? statistics.percentiles;

    result.percentiles = incomingPercentiles;
  } else if (statistics.originalPercentiles) {
    result.percentiles = statistics.originalPercentiles;
  }

  return result;
}

export function updateFilter(filter, layerFilterName, percentiles) {
  if (filter.formula !== layerFilterName) return filter;

  return {
    ...filter,
    statistics: updateStatistics(filter.statistics, percentiles)
  };
}
